<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="alertOverdue.show"
            @hidden="alertOverdue.show = false"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">แจ้งเตือนยอดค้างชำระ</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h4 class="text-red">คุณมียอดค้างชำระจากรายการน้ำหนักพัสดุเกิน</h4>
                        <small class="text-muted">หากคุณมียอดค้างชำระเกิน 500 บาท จะไม่สามารถสร้างรายการส่งพัสดุได้</small>
                        <hr class="my-4" />
                    </div>
                    <div class="row px-6">
                        <div class="col-lg-12">
                            <h4>รายการค้างชำระ</h4>
                        </div>
                        <div class="col-lg-6">
                            <h4>จำนวนทั้งหมด {{alertOverdue.nums}} รายการ</h4>
                        </div>
                        <div class="col-lg-6 text-right">
                            <h4>฿{{alertOverdue.creditOverdue}}</h4>
                        </div>
                    </div>
                    <div class="col-lg-12 text-center">
                        <hr class="my-4" />
                        <router-link to="/">
                            <b-button 
                                class="px-4 mx-2"
                            >
                                ปิด
                            </b-button>
                        </router-link>
                        <router-link to="/">
                            <b-button 
                                class="px-4 mx-2" 
                                variant="info" 
                            >
                                ดูรายการค้างชำระ
                            </b-button>
                        </router-link>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModelAlertOverdueBalance" ,
    props: {
        alertOverdue: Object,
    },
    data(){
        return{
         
        }
    },
    methods:{
        
    }
}
</script>
